"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _routesPropType = require("./routesPropType");

var _core = require("@material-ui/core");

var _styles = require("@material-ui/core/styles");

var _tinycolor = _interopRequireDefault(require("tinycolor2"));

var _MenuItem = _interopRequireDefault(require("../MenuItem"));

var _ListItem = _interopRequireDefault(require("../ListItem"));

var _Link = _interopRequireDefault(require("../Link"));

var _ConnectedLink = _interopRequireDefault(require("../ConnectedLink"));

var _CollapsingItemElement = _interopRequireDefault(require("../CollapsingItemElement"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var NavListStateless = function NavListStateless(_ref) {
  var routes = _ref.routes,
      _toggleCollapse = _ref.toggleCollapse,
      style = _ref.style,
      _onClick = _ref.onClick,
      isMenu = _ref.isMenu,
      isNestedMenu = _ref.isNestedMenu,
      itemProps = _ref.itemProps,
      linkProps = _ref.linkProps,
      otherProps = _objectWithoutProperties(_ref, ["routes", "toggleCollapse", "style", "onClick", "isMenu", "isNestedMenu", "itemProps", "linkProps"]);

  var theme = (0, _styles.useTheme)();
  var currentBgColor = style && style.backgroundColor || theme.palette.background.paper;
  var newBgColor = (0, _tinycolor.default)(currentBgColor).darken(8).toRgbString();
  var ListElement = isMenu ? _core.Menu : _core.List;
  var ItemElement = isMenu ? _MenuItem.default : _ListItem.default;
  return _react.default.createElement(ListElement, _extends({
    style: style
  }, otherProps), routes && routes.map(function (route) {
    var to = route.link || route.pathWithParams || (Array.isArray(route.path) ? route.path[0] : route.path);
    var LinkElement = to ? route.link ? _Link.default : _ConnectedLink.default : 'div';
    var reactKey = route.key;
    return (// @HACK it has to be an array because Menu and List 
      // elements wants an array not a single element
      [route.separator && route.separator.above ? _react.default.createElement(_core.Divider, {
        key: "".concat(reactKey, "-divider-up")
      }) : null, route.type === 'group' ? _react.default.createElement(_CollapsingItemElement.default, {
        key: reactKey,
        isMenu: isMenu,
        icon: route.icon,
        label: route.name,
        isOpen: Boolean(route.isOpen),
        toggleCollapse: function toggleCollapse() {
          return _toggleCollapse(route.key);
        },
        itemProps: itemProps
      }, _react.default.createElement(NavListStateless, _extends({
        routes: route.routes,
        isMenu: Boolean(isNestedMenu),
        isNestedMenu: isNestedMenu,
        itemProps: itemProps,
        linkProps: linkProps,
        onClick: _onClick,
        toggleCollapse: _toggleCollapse,
        style: isNestedMenu ? {} : {
          backgroundColor: newBgColor
        }
      }, otherProps))) : _react.default.createElement(LinkElement, _extends({
        key: reactKey,
        to: to
      }, linkProps), _react.default.createElement(ItemElement, _extends({
        icon: route.icon,
        label: route.name,
        onClick: function onClick() {
          route.onClick && route.onClick.apply(route, arguments);
          _onClick && _onClick.apply(void 0, arguments);
        },
        selected: route.isSelected
      }, itemProps))), route.separator && route.separator.below ? _react.default.createElement(_core.Divider, {
        key: "".concat(reactKey, "-divider-down")
      }) : null]
    );
  }));
};

NavListStateless.propTypes = {
  isMenu: _propTypes.default.bool,
  style: _propTypes.default.object,
  onClick: _propTypes.default.func,
  itemProps: _propTypes.default.object,
  linkProps: _propTypes.default.object,
  isNestedMenu: _propTypes.default.bool,
  routes: _routesPropType.routesPropType,
  toggleCollapse: _propTypes.default.func.isRequired
};
var _default = NavListStateless;
exports.default = _default;